import React, { useEffect, useState } from 'react';
import { Toast, Modal, OverlayTrigger, Tooltip, Row, Form } from 'react-bootstrap';
import api from '../../seller-apis/api';
import RaiseConcernModal from '../common/RaiseConcernModal';
import {
  negotiationReq,
  orderRevoke,
  filterOrders,
  pdetailData
} from '../../seller-apis/apidataField';
import PaginationCom from '../common/Pagination';
import ConfirmationModal from '../common/ConfirmationModal';
import Popup from '../common/Popup';
import TrackOrderPopup from '../common/TrackOrder-Popup';
import '../order.css';
import OrderCardWeb from '../common/OrderCardWeb';
import { useAlert } from 'react-alert';
import { useOrderDateAlert, resetOrderDateFilter, resolveOrderDateRange, resetOrderDateFilter60Day } from './useOrderDateAlert';
import ProductSearch from '../common/ProductSearch';
import OrderSKUSearch from '../common/ProductSearch/OrderSKUSearch';
import OrdersTabs from './OrdersTab';
import moment from 'moment';
import WeightComponent from '../common/WeightComponent'
import { useDispatch, useSelector } from 'react-redux';
import { resetPackages, setInitialPackages, setReferencePackage } from '../../Actions/PackageWeight';
import { packagesCmtoFt, packagesFttoCm } from '../../utilities/conversion';
import variables from '../../Variables.json'
import { arePackagesEqual, checkIsPkgMediaNotPresent, sanitizePkgImages } from '../../utilities/packages';
import axios from 'axios';
import HSNModal from '../common/HSNModal';
import MainLoader from '../common/Loader/PageLoader';
import { Actions } from '../../Actions/Actions';
var dateFromWeb;

var dateToWeb;
var dateFrom3days;
var datesWeb;


var globalFilter = {
  "pageNo": 1,
  "statusFilter": ["ASSIGN"],
  "dates": {

  }
};
var sorted = true;
function UnProcessedOrders(props) {
  const stateData = useSelector(state => state?.ActionReducer);//SL-923
  var outerdiv;
  var loaderDiv;
  dateFrom3days = moment().subtract(4, 'days').format('YYYY-MM-DD');
  const alert = useAlert()
  const showOrderDateAlert = useOrderDateAlert(alert)

  const [revokedOrd, setrevokedOrd] = useState([]);
  const [newOrdersList, setnewOrdersList] = useState([]);
  const [ennewloader, setennewloader] = useState("block");
  const [negotiationRequests, setnegotiationRequests] = useState([]);
  const [newRecords, setnewRecords] = useState();

  const [selectedOrder, setSelectedOrder] = useState();


  // Web states

  const [allOrders, setallOrders] = useState([]);
  const [allRecords, setallRecords] = useState(1);
  const [breachingDataCount, setBreachingDataCount] = useState(0);
  const [webFiltCurr, setwebFiltCurr] = useState();
  // Pagination related

  const [selectedPage, setSelectedPage] = useState(1);



  // Sort Filter States

  const [sortHistdatefrom, setHistsortdatefrom] = useState();
  const [sortHistdateto, setHistsortdateto] = useState();



  // Confirmation related
  const [confirmationState, setconfirmationState] = useState(false)
  const [msgConfirmation, setmsgConfirmation] = useState();
  const [confirmationFor, setconfirmationFor] = useState();
  const [negotiateState, setnegotiateState] = useState();
  const [confirmationType, setconfirmationType] = useState();
  const [selectedOrdername, setSelectedOrdername] = useState();
  // Toast

  const [showToast, setshowToast] = useState(false)
  const [toastmsg, setToastmsg] = useState("")
  const [compforPaginationweb, setcompforPaginationweb] = useState("allOrdersWeb");



  // Track order Popup

  const [selectedtrackOrder, setselectedtrackOrder] = useState(0);
  const [selectedTrackwithin, setselectedTrackwithin] = useState(0);
  const [searchType, setSearchType] = useState("Product Name");
  const [minValDate, setMinValDate] = useState("")
  //Product Detail Popup

  const [productDetail, setproductDetail] = useState([
    {
      "description": undefined,
      "sdescription": undefined,
      "name": undefined,
      "price": undefined,
      "SKU": undefined,
      "popupVisibility": undefined,
      "images": []
    }
  ]);
  const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
  const [defUrl, setdefUrl] = useState();


  // Web filter related states
  const [addressName, setAddressName] = useState("")
  const [orderId, setOrderId] = useState(undefined);
  const [orderName, setorderName] = useState();
  const [currInput, setcurrInput] = useState(["ASSIGN"]);
  const [sortdatewebFilt, setsortdatewebFilt] = useState("new");
  const [isPopupTrackVisWeb, setisPopupTrackVisWeb] = useState("block");
  const [selectedtrackOrderWeb, setselectedtrackOrderWeb] = useState(0);
  const [detailPPrice, setdetailPPrice] = useState("");

  const [removeFilterClass, setremoveFilterClass] = useState("invent_remove_filter_btn")

  // sl -712
  const [verifyManifestPopup, setVerifyManifestPopup] = useState(false);
  const [currentClickedOrder, setCurrentClickedOrder] = useState(null);
  const [currentStep, setCurrentStep] = useState(0)
  const [tpDisabled, setTpDisabled] = useState(true)
  const [stockDisabled, setStockDisabled] = useState(true)
  const [verTrPrice, setVerTrPrice] = useState(null)
  const [currentStock, setCurrentStock] = useState(null)
  const [clickedProDets, setClickedProDets] = useState()
  const [weightChangeStatus, setWeightChangeStatus] = useState("")
  const { packages, initialPackages, dimensionUnit } = useSelector(state => state.packageReducer)
  const [acceptPackageSelected, setAcceptPackageSelected] = useState(false);
  const [rejectPackageSelected, setRejectPackageSelected] = useState(false)
  const dispatch = useDispatch()
  //<Start-Here> Ticket: SL-669
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [show, setShow] = useState(false);
  const [isBreachingFilter, setBreachingFilter] = useState(false);
  //</End-Here> Ticket: SL-669
  //SL-675
  const [totalRcordId, setTotalReordId] = useState([]);

  // l1-2319 (2-9-25)
  const [showHSNModal, setShowHSNModal] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [isWeightVerifyOnly, setIsWeightVerifyOnly] = useState(false);

  const handleHSNModalOpen = (product) => {
    setShowHSNModal(true);
    setCurrentProduct(product);
    console.log(product)
  }
  const handleHSNModalClose = () => {
    setShowHSNModal(false);
    setCurrentProduct(null);
  }
  const handleHSNModalSave = async ({ productId, hsnCode, gstRate }) => {
    let data = {
      _id: productId,
      HSN: hsnCode,
      taxClass: gstRate
    }
    try {
      let res = await api.product.addToExProduct(data)
      if (res.message === "product updated" || res.message === "product added") {
        alert.success("HSN Updated Successfully!");
        getOrders()
      }
      else {
        alert.info(res.message);
      }
    }
    catch (err) {
      alert.info("Failed to update HSN");
      console.log(err);
    }
    finally {
      handleHSNModalClose();
    }
  }

  useEffect(() => {
    const { from, to } = resetOrderDateFilter60Day();
    dateFromWeb = from;
    dateToWeb = to;
    setHistsortdatefrom(from);
    setHistsortdateto(to);
    setselectedTrackwithin(0)
    setselectedtrackOrder(0)
    setselectedtrackOrderWeb(0)
    setSelectedPage(1)
    globalFilter = {
      "pageNo": 1,
      "statusFilter": ["ASSIGN"],
      "dates": {

      }
    }
    
    //<Start-Here> Date and Breaching Soon | Ticket : SL-931
    /*if (dateFromWeb === undefined || dateToWeb === undefined || dateFromWeb === "" || dateToWeb === "") {
      showOrderDateAlert("please select both date", "show");
      return false;
    }*/
    if (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !== "") {
      /*let fromDate = new Date(dateFromWeb)
      let toDate = new Date(dateToWeb);
      let diffDate = toDate.getTime() - fromDate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if(daydiffer > 30){
          showOrderDateAlert("Date range cannot be more than 30 days.")
          return 0;
      }*/
      globalFilter.dates = {
        "from-createdAt": dateFromWeb + 'T00:00:00',//SL-669
        "to-createdAt": dateToWeb + 'T23:59:59'
      }
    }
    //</End-Here> Date and Breaching Soon | Ticket : SL-931
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.productId.productName": orderName,
      "products.vendorDetails.addrName": addressName,
      "orderId": orderId,
    }
    applyLoader()
    if (orderId !== undefined || orderName !== undefined || addressName !== undefined || (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !== "")) {
      setremoveFilterClass("invent_remove_filter_btn_active")
    }
    //SL-675
    globalFilter["productId"] = totalRcordId.length == 0 ? true : false;
    api.order?.orders(filterOrders(globalFilter)).then((res) => {
      removeLoader()
      setdefUrl("manual-mandava-weeder")
      setallOrders(res.data)
      setallRecords(res.totalRecords)
      if (totalRcordId.length == 0) {//SL-675
        setTotalReordId(res?.productId);
        globalFilter["productId"] = false;
      }
    }).catch(err => {
      removeLoader()
      console.log(err)
    })
    //<Start-Here> Date and Breaching Soon | Ticket : SL-931
    // before 3 days data
    const breachingFilter = {
      ...globalFilter,
      dates: {
        ...globalFilter.dates
      },
      orderFilter:{
        ...globalFilter.orderFilter
      },
      size: 1
    };
    breachingFilter.dates["to-createdAt"] = dateFrom3days + 'T23:59:59'; //'T00:00:00.000Z'; //SL-923
    api.order?.orders(filterOrders(breachingFilter)).then((res) => {
      setBreachingDataCount(res.totalRecords);
      //delete breachingFilter.dates["to-orderPlaceDate"];
    }).catch(err => {
      // removeLoader()
      console.log(err)
    })
  }, [])




  useEffect(() => {
    if (addressName === "" || addressName === null) {
      setAddressName(undefined)
    }
  }, [addressName])


  useEffect(() => {
    if (orderId === "" || orderId === null) {
      setOrderId(undefined)
      if (globalFilter?.orderFilter?.orderId){
        delete globalFilter.orderFilter.orderId;
        globalFilter.pageNo = 1;
        setSelectedPage(1)
        getOrders()
      }
    }
  }, [orderId])


  useEffect(() => {
    if (orderName === "" || orderName === null) {
      setorderName(undefined)
    }
  }, [orderName])

  // sl -712
  useEffect(() => {
    if (!verifyManifestPopup) {
      setAcceptPackageSelected(false)
      setRejectPackageSelected(false)
      dispatch(resetPackages())
      setTpDisabled(true)
      setStockDisabled(true)
      setCurrentStock(null)
      setVerTrPrice(null)
      setCurrentStep(1)
      setIsWeightVerifyOnly(false) // ✅ add this line
    }
  }, [verifyManifestPopup])


  // Order Picked
  function productPicked(id, status, pname) {
    if (status === "ASSIGN") {
      setToastmsg("Download manifest to proceed with pickup.")
      setshowToast(true)
    }
    else if (status === "DOWNLOAD") {
      setSelectedOrder(id)
      setSelectedOrdername(pname)
      setmsgConfirmation("Is product picked up by courier boy?")
      setconfirmationState(true)
    }
  }

  // Manifest Download Confirmation
  function isManifestDownloaded(res) {
    let loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex")
    console.log(res)
    console.log(webFiltCurr, compforPaginationweb, datesWeb)
    if (res === "yes") {
      updatePickupRequestCount()
      setTimeout(() => {
        setennewloader("flex");
        api.order?.orders(filterOrders(globalFilter)).then((res) => {
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        }).catch(err => {
          console.log(err)
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        })
      }, 500);
    }
  }

  // SL-1159
  const updatePickupRequestCount = () => {
       let pickupRequestFilter = {
          "pageNo": 1,
          "size": 1,
          "statusFilter": ["Pickup Pending"],
          "dates":{
            "from-createdAt": dateFromWeb + 'T00:00:00',
            "to-createdAt": dateToWeb + 'T23:59:59'
          },
          "sortFilter": {
            "createdAt": -1
          },
        }
        api.order.orders(filterOrders(pickupRequestFilter)).then((res) => {
          Actions.OrderCountAction(dispatch, {pickupRequest:res.totalRecords});
        }).catch(err => {
          console.log(err)
        })

  }

  // Confirmation Modal

  function confirmationBoxHiding(state) {
    if (state === false) {
      setconfirmationState(false)
    }
  }

  function responseconfirmation(response, id) {
    let data = {
      "_id": id,
      "status": "PICKED"
    }
    if (response === "yes") {
      setconfirmationState(false)
      api.order?.updateOrder(data).then((res) => {
        let filterData = {
          "pageNo": selectedPage,
        }
        alert.success("Order status updated")
        setTimeout(() => {
          api.order?.orders(filterOrders(globalFilter)).then((res) => {
            setnewOrdersList(res.data)
            setnewRecords(res.totalRecords)
          }).catch(err => {
            console.log(err)
          })
        }, 500);
      }).catch((err) => {
        console.log(err)
      })
    }
  }

  // Negotiation confirmation related

  function responseConfirmNegotiate(ans, id) {
    let filterData = {
      "pageNo": selectedPage
    }


    if (ans === "yes") {
      setconfirmationState(false)
      if (negotiateState === "accept") {
        let data = {
          "_id": id,
          "status": "APPROVED"
        }
        api.order?.updateOrder((data)).then((res) => {
          alert.success("Offer accepted")
          api.order?.orders(negotiationReq(filterData)).then((response) => {
            setnegotiationRequests(response.data)
          }).catch(err => {
            console.log(err)
          })
        }).catch((err) => {
          console.log(err)
        })
      }
      else if (negotiateState === "reject") {
        let data = {
          "_id": id,
          "status": "DISAPPROVED"
        }
        api.order?.updateOrder((data)).then((res) => {
          alert.success("Offer rejected")
          api.order?.orders(negotiationReq(filterData)).then((response) => {
            setnegotiationRequests(response.data)
          }).catch(err => {
            console.log(err)
          })
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }

  function setpopupVisibilityDetail(e) {
    if (e) {
      setisDetailPopupVis("block")
    }
    else {
      setisDetailPopupVis("none")
    }
  }


  function setpopupVisibilitytrackWeb(e) {
    if (e) {
      setisPopupTrackVisWeb("block")
    }
    else {
      setisPopupTrackVisWeb("none")
    }
  }



  function trackPopupWeb(e, trackNo, docketNo) {
    setselectedtrackOrderWeb(e)
    setselectedTrackwithin(trackNo)
  }



  function checkevent(e, name, selectedAddress = null) {//SL-923
    // setHistsortdatefrom("")
    // setHistsortdateto("")

    if (e.keyCode === 13) {
      let loaderDiv = document.getElementById("enNewLoader");

      if (name === "id" && orderId !== "") {
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        globalFilter.pageNo = 1
        globalFilter.orderFilter = {
          ...globalFilter.orderFilter,
          "orderId": orderId
        }
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res) => {
          console.log(res)
          setallOrders(res.data)
          setallRecords(res.totalRecords);
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        }).catch(err => console.log(err));
      }
      else if (name === "id" && orderId === "") {
        setSelectedPage(1)
        globalFilter.pageNo = 1;
        setcompforPaginationweb("allOrdersWeb")
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        globalFilter.pageNo = 1
        globalFilter.orderFilter = {
          ...globalFilter.orderFilter,
          "orderId": undefined
        }
        api.order?.orders(filterOrders(globalFilter)).then((res) => {
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        }).catch(err => console.log(err));
      }
      else if (name === "name" && orderName !== "") {
        setSelectedPage(1)
        let ordersearchFilter = searchType != 'sku' ? { "products.productId._id": orderName } : { "products.productId._id": orderName };
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        setcompforPaginationweb("webFilt")

        globalFilter.pageNo = 1
        globalFilter.orderFilter = {
          ...ordersearchFilter
        }
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res) => {
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setwebFiltCurr("name");
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        }).catch(err => console.log(err))
      }
      else if (name === "name" && orderName === "") {
        setSelectedPage(1)
        setcompforPaginationweb("allOrdersWeb")
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        globalFilter.pageNo = 1
        globalFilter.orderFilter = {
          ...globalFilter.orderFilter,
          "products.productId.productName": undefined,
        }
        api.order?.orders(filterOrders(globalFilter)).then((res) => {
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        }).catch(err => console.log(err));
      }
      else if (name === "address" /*&& addressName !== ""*/) {//SL-923
        setSelectedPage(1)
        setcompforPaginationweb("allOrdersWeb")
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        setremoveFilterClass("invent_remove_filter_btn_active")
        globalFilter.pageNo = 1;
        globalFilter.orderFilter = {
          ...globalFilter.orderFilter,
          "products.vendorDetails.addrName": selectedAddress //addressName // SL-923
        }
        api.order?.orders(filterOrders(globalFilter)).then((res) => {
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          console.log('addresses', res.totalRecords)
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        }).catch(err => console.log(err));
      }
    }
  }


  // Popup showing detail
  function detail(data, price) {
    setdetailPPrice(price)
    if (data && data[0] === undefined) {
      setproductDetail(
        [
          {
            "description": "No details available",
            "sdescription": "No short description",
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
          }
        ]
      )
    }
    else {
      setproductDetail(data)
    }
  }

  // Pagination

  function paginate(data) {
    let loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex")
    setselectedTrackwithin(0)
    setselectedtrackOrder(0)
    setselectedtrackOrderWeb(0)
    setSelectedPage(data.number)
    globalFilter.pageNo = data.number
    //SL-931
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
    }
    globalFilter.dates = {
      ...globalFilter.dates,
            "to-createdAt": isBreachingFilter
        ? dateFrom3days + 'T23:59:59' //'T00:00:00.000Z'  //SL-923
        : dateToWeb + 'T23:59:59' //'T00:00:00.000Z' //SL-923
    }
    setennewloader("flex");
    api.order?.orders(filterOrders(globalFilter)).then((res) => {
      setallOrders(res.data)
      setallRecords(res.totalRecords)
      loaderDiv.classList.remove("loader-bt");
      setennewloader("none")
    }).catch(err => {
      console.log(err)
      loaderDiv.classList.remove("loader-bt");
      setennewloader("none")
    })

  }


  function setdateweb(e, type) {
    const { from, to } = resolveOrderDateRange(type, e.target.value, dateFromWeb, dateToWeb);
    dateFromWeb = from;
    dateToWeb = to;
    setHistsortdatefrom(from);
    setHistsortdateto(to);
    /*if (dateFromWeb !== undefined && dateToWeb != undefined) {
      let fromDate = new Date(dateFromWeb)
      let toDate = new Date(dateToWeb);
      let diffDate = toDate.getTime() - fromDate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      console.log(daydiffer)
      if (daydiffer > 30) {
        showOrderDateAlert('Date range cannot be more than 30 days.')
      }
      else if (daydiffer < 0) {
        showOrderDateAlert("Please select a valid date range.")
      }
    }*/
  }



  // Revoke update

  function revCheck(status) {
    console.log(status)
    if (status === "success") {
      alert.success("Updated successfully")
      api.order?.orders(orderRevoke()).then((res) => {
        setrevokedOrd(res.data)
      }).catch((err) => {
        console.log(err)
      })
    }
  }


  // Function to close all popups opened

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.key === "Esc" || evt.key === "Escape") {
      setconfirmationState(false)
      setisPopupTrackVisWeb("none")
      setisDetailPopupVis("none")
    }
  };


  function downloadManifestToast() {
    setToastmsg("Manifest not yet generated, Please try after sometime.")
    setshowToast(true)
  }

  function applyLoader() {
    loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex")
  }

  // remove loader

  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setennewloader("none")
  }


  function clearFilters() {
    applyLoader()
    setcompforPaginationweb("allOrdersWeb")
    globalFilter = {
      "pageNo": 1,
      "statusFilter": ["ASSIGN"],
      "dates": {

      }
    }
    setorderName("")
    setOrderId("")
    setAddressName("")
    setHistsortdatefrom("")
    setHistsortdateto("")
    dateFromWeb = ""
    dateToWeb = ""
    setSelectedPage(1)
    setselectedTrackwithin(0)
    setselectedtrackOrder(0)
    setselectedtrackOrderWeb(0)
    api.order?.orders(filterOrders(globalFilter)).then((res) => {
      console.log(res)
      removeLoader()
      setremoveFilterClass("invent_remove_filter_btn")
      setdefUrl("manual-mandava-weeder")
      setallOrders(res.data)
      setallRecords(res.totalRecords)
      setennewloader("none")
    }).catch(err => {
      setennewloader("none")
      console.log(err)
    })
  }

  function applyFilter() {
    setselectedTrackwithin(0)
    setselectedtrackOrder(0)
    setselectedtrackOrderWeb(0)
    setSelectedPage(1)
    globalFilter.pageNo = 1
    //SL-931
    /*if (dateFromWeb === undefined || dateToWeb === undefined || dateFromWeb === "" || dateToWeb === "") {
      showOrderDateAlert("please select both date", "show");
      return false;
    }*/
    if (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !== "") {
      /*let fromDate = new Date(dateFromWeb)
      let toDate = new Date(dateToWeb);
      let diffDate = toDate.getTime() - fromDate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)

      if(daydiffer > 60){
          showOrderDateAlert("Date range cannot be more than 30 days.")
          return 0;
      }*/
      //SL-931
      /*globalFilter.dates = {
        ...globalFilter.dates,
        //SL-931
        "from-orderPlaceDate": dateFromWeb + 'T00:00:00',//SL-669
        "to-orderPlaceDate": dateToWeb + 'T23:59:59'
      }*/
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.productId.productName": orderName,
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.vendorDetails.addrName": addressName
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "orderId": orderId
    }
    applyLoader()
    if (orderId !== undefined || orderName !== undefined || addressName !== undefined || (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !== "")) {
      setremoveFilterClass("invent_remove_filter_btn_active")
    }
    api.order?.orders(filterOrders(globalFilter)).then((res) => {
      removeLoader()
      setdefUrl("manual-mandava-weeder")
      setallOrders(res.data)
      setallRecords(res.totalRecords)
    }).catch(err => {
      removeLoader()
      console.log(err)
    })

    // before 3 days data
    const breachingFilter = {
      ...globalFilter,
      dates: {
        ...globalFilter.dates
      },
      size: 1
    }
    breachingFilter.dates["to-createdAt"] = dateFrom3days + 'T23:59:59'; //'T00:00:00.000Z'; //Sl-923
    api.order?.orders(filterOrders(breachingFilter)).then((res) => {
      setBreachingDataCount(res.totalRecords);
      //delete breachingFilter.dates["to-orderPlaceDate"];
    }).catch(err => {
      // removeLoader()
      console.log(err)
    })

  }

  const filterSearch = (data) => {
    //setorderName(data.data);
    //setSearchType(data.type)
    applyLoader();
    globalFilter['filters'] = { ...globalFilter.filters, "product-objectId": data.data }
    //Search Issue on Other than 1st Page SL-698 and SL-675
    if (globalFilter?.searchIds)
      delete globalFilter['searchIds'];
    globalFilter.pageNo = 1;
    setSelectedPage(1)
    //<Start-Here> Wrong Query in search | Ticket : I1-2330
    //SL-931
    globalFilter.dates = {
      ...globalFilter.dates,
            "to-createdAt": isBreachingFilter
        ? dateFrom3days + 'T23:59:59' //'T00:00:00.000Z'  //SL-923
        : dateToWeb + 'T23:59:59' //'T00:00:00.000Z' //SL-923
    }
    //</End-Here> Wrong Query in search | Ticket : I1-2330
    api.order?.orders(filterOrders(globalFilter))
      .then((res) => {
        removeLoader()
        setallOrders(res.data)
        setallRecords(res.totalRecords)
      }).catch(err => {
        removeLoader()
        console.log(err)
      })
  }

  const getOrders = () => {
    try {
      console.log(globalFilter)
      applyLoader()
      api.order.orders(filterOrders(globalFilter)).then((res) => {
        removeLoader()
        setdefUrl("manual-mandava-weeder")
        setallOrders(res.data)
        setallRecords(res.totalRecords)
      }).catch(err => {
        throw new Error(err)
      })
    } catch (err) {
      removeLoader()
      console.log(err)
    }
  }

  useEffect(() => {
    if (orderName !== "" && orderName !== null && orderName !== undefined) {
      checkevent({ "keyCode": 13 }, "name");
    }
  }, [orderName])

  const sort = (field) => {
    globalFilter.sortFilter = {};
    if (sorted) {
      sorted = false;
      globalFilter.sortFilter[field] = 1;
    } else {
      sorted = true;
      globalFilter.sortFilter[field] = -1;
    }
    applyFilter();
  }


  //<Start-Here>Raise Concern  Ticket: SL-660
  /**
 * Apply breaching Soon FIlter
 */
  function applyBreachingSoonFilter() {
    setBreachingFilter(true);
    globalFilter.dates = {
      ...globalFilter.dates,
            "to-createdAt": dateFrom3days + 'T23:59:59' //'T00:00:00.000Z' //SL-923
    }
    applyFilter();
  }
  /**
   * Remove breaching Soon FIlter
   */
  function removeBreachingSoonFilter() {
    setBreachingFilter(false);
    //SL-931
    //delete globalFilter.dates["to-orderPlaceDate"];
    globalFilter.dates = {
      ...globalFilter.dates,
            "to-createdAt": dateToWeb + 'T23:59:59'
    }
    if (globalFilter?.dates?.["to-updatedAt"]) {
      delete globalFilter?.dates["to-updatedAt"];
    }
    applyFilter();
  }
  /**
   * Show the Raise Concern Modal
   */
  function showRaiseConcern(orderId) {
    setSelectedOrderId(orderId);
    setShow(true);
  }
  /**
   * Close the Raise Concern Modal
   */
  const handleRaiseConcernClose = () => {
    setShow(false);
  };
  /**
   * Submit the Raise Concern
   */
  const submitRaiseConcern = (concern) => {
    setShow(false);
    const breachingConcern = {
      concern,
      orderId: selectedOrderId
    }
    api.order?.breachingConcern(breachingConcern).then((res) => {
      alert.info("Concern Submitted Successfully!");
    }).catch(err => {
      console.log(err)
    })
  }
  //</End-Here>Raise Concern  Ticket: SL-669
  //<Start-Here> Serach Ticket: SL-675
  /**
 * API Calling
 */
  const ApiCalling = (flag) => {
    applyLoader()
    if (globalFilter?.searchIds)
      delete globalFilter['searchIds'];
    globalFilter.pageNo = selectedPage;
    console.log(globalFilter)
    if (flag === "reset") {
      delete globalFilter?.filters?.["product-objectId"];
      globalFilter.pageNo = 1;
      setSelectedPage(1)
    }

    //<Start-Here> Wrong Query in search | Ticket : I1-2330
    //SL-931
    globalFilter.dates = {
      ...globalFilter.dates,
            "to-createdAt": isBreachingFilter
        ? dateFrom3days + 'T23:59:59' //'T00:00:00.000Z'  //SL-923
        : dateToWeb + 'T23:59:59' //'T00:00:00.000Z' //SL-923
    }
    
    //</End-Here> Wrong Query in search | Ticket : I1-2330
    api.order?.orders(filterOrders(globalFilter))
      .then((res) => {
        removeLoader()
        setallOrders(res.data)
        setallRecords(res.totalRecords)
      }).catch(err => {
        removeLoader()
        console.log(err)
      })
  }

  // sl-712
  // sachin
  const manifestDetailsVerify = (index, step = null) => {
    setIsWeightVerifyOnly(true);
    setCurrentClickedOrder(allOrders[index])
    let data = {
      pId: allOrders[index].product,
    };
    if (step !== null) setCurrentStep(1)
    api.product.productsRetrieveall(pdetailData(data)).then((res) => {
      setClickedProDets(res?.products[0])
      if (res?.products[0]?.vendors?.[0]?.combination.length > 0) {
        let comb = res?.products[0]?.vendors?.[0]?.combination.filter((item) => item?.url === allOrders[index].order?.products[0]?.selSubPrd?.url)
        setVerTrPrice(comb[0]?.purchase_price)
        setCurrentStock(comb[0]?.stock)
        res.products[0].pkgs.map((item1, indexx) => {
          if (item1.url === comb[0].url) {
            setWeightChangeStatus(comb[0]?.sellerWeightChangeSts)
            if (comb[0]?.sellerWeightChangeSts === "T_PENDING") {
              fetchPendingWeightPackages(allOrders[index].product, comb[0].url)
            }
            else {
              // if (res.products[0]?.isDefaultPkg) {
              //   dispatch(resetPackages())
              // }
              // else {
              dispatch(setInitialPackages(packagesCmtoFt(item1.pkgs)))
              // }
            }
          }
        })
        res?.products[0]?.combination.map((lItem, lIndex) => {
          if (lItem.url === comb[0].url) {
            dispatch(setReferencePackage(packagesCmtoFt(lItem?.lowestPkgs)))
          }
        })
      }

      else {

        if (res?.products[0]?.vendors?.[0]?.sellerWeightChangeSts === "T_PENDING") {
          fetchPendingWeightPackages(allOrders[index].product)
        }
        else {
          // if (res?.products[0]?.isDefaultPkg) {
          //   dispatch(resetPackages())
          // }
          // else {
          dispatch(setInitialPackages(packagesCmtoFt(res?.products[0]?.pkgs)))
          // }
        }
        setVerTrPrice(res?.products[0]?.vendors?.[0]?.purchase_price)
        setCurrentStock(res?.products[0]?.vendors?.[0]?.stock)
        setWeightChangeStatus(res?.products[0]?.vendors?.[0]?.sellerWeightChangeSts)
        dispatch(setReferencePackage(packagesCmtoFt(res?.products[0]?.lowestPkgs)))
      }
      setVerifyManifestPopup(true)
    }).catch(err => console.log(err))
  }

  const fetchPendingWeightPackages = (product, url = null) => {
    api.product.getSellerWeightChangePendingReq({ "product": product, "pkg.url": url }).then((res) => {
      dispatch(setInitialPackages(packagesCmtoFt(res?.data?.pkgs)))
    })
  }

  const verManifestValidation = {
    step0: () => {
      if (verTrPrice === undefined || verTrPrice === null || verTrPrice < 1) {
        alert.info('Please enter a valid transfer price.')
        return false;
      }
      return true;
    },
    step2: () => {
      if (currentStock !== undefined && currentStock !== null && currentStock !== "") {
        if (Number(currentStock) < 0) {
          alert.info('Please enter a valid stock value.')
          return false;
        }
      }
      return true;
    }
  }

  const verSubmitTPrice = () => {
    const isValid = verManifestValidation.step0()
    if (isValid) setCurrentStep(1)
  }

  const handleVerPackageSubmission = (packages) => {
    let sellerWeightChangeStsTemp = currentClickedOrder?.order?.products[0]?.sellerWeightChangeSts
    if((sellerWeightChangeStsTemp === "T_ACTIVE" || sellerWeightChangeStsTemp === "T_PENDING") && checkIsPkgMediaNotPresent(packages)){
        alert.info("Please add at least one image to update package details.")
        return;
    }
    submitVerifyManifest()
  }

  // update seller weight change sts
  const updateSellerWeightChangeSts = async (status) => {
    let data = {
      product: currentClickedOrder?.product,
      sellerWeightChangeSts: status,
    };

    if (currentClickedOrder?.order?.products[0]?.selSubPrd?.url) {
      data["url"] = currentClickedOrder?.order?.products[0]?.selSubPrd?.url
    }
    await api.product.sellerWeightChangeStsUpdate(data);
  }

  const handleAcceptPackage = () => {
    setAcceptPackageSelected(true)
    handleVerPackageSubmission()
  }

  // l1-2110
  // download manifest on tv weight acceptance 

  async function downloadManifest() {
    const invoices = currentClickedOrder?.order?.products[0]?.tracks[0]
    const orderMainId = currentClickedOrder?.order?._id
    const currOrderId = currentClickedOrder?.order?.orderId + currentClickedOrder?.order?.products[0]?.productId?.SKU + '.pdf'
    if (currentClickedOrder?.status === "ASSIGN" || currentClickedOrder?.status === "DOWNLOAD") {


      if (invoices?.shippingBy === "ROCKET BOX" || invoices?.shippingBy === "ROCKETBOX-MANUAL") {
        downloadManifestPdf();
        api.order.rocketBoxManifest({ _id: orderMainId }).then((res) => {
          console.log(res)

          const link = document.createElement('a');
          link.href = res.data.label_url;
          link.setAttribute('download', currOrderId);
          document.body.appendChild(link);
          link.click();

        }).catch((error) => {
          console.error('Error downloading manifest:', error);
        });
      }
      else if (invoices?.shippingBy === "SHIPROCKET") {
        downloadManifestPdf();
        const link = document.createElement('a');
        link.href = invoices.label_url;
        link.setAttribute('download', currOrderId);
        document.body.appendChild(link);
        link.click();


      }
      else {
        downloadManifestPdf();
      }
    }
    else {
      axios({
        url: invoices,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        if (response.status === 200) {
          const newurl = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = newurl;
          // downloadName = url.slice(77);
          link.setAttribute('download', currOrderId);
          document.body.appendChild(link);
          link.click();
          window.open(response.config.url, '_blank');
        }
      }).catch((err) => console.log(err))
    }


    if (currentClickedOrder?.status === "ASSIGN") {

      let data = {
        "_id": currentClickedOrder?._id,
        "status": "DOWNLOAD",
        "platform": 'WEB'
      }
      api.order.updateOrder(data).then((res) => {
      }).catch(err => console.log(err))
    }
  }

  const downloadManifestPdf = () => {
    const invoices = currentClickedOrder?.order?.products[0]?.tracks[0]
    const currOrderId = currentClickedOrder?.order?.orderId + currentClickedOrder?.order?.products[0]?.productId?.SKU + '.pdf'
    axios({
      url: invoices?.invoice,
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      if (response.status === 200) {
        console.log(response)
        const newurl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = newurl;
        // downloadName = url[i].invoice.slice(77);

        link.setAttribute('download', currOrderId);
        document.body.appendChild(link);
        link.click();
        window.open(response.config.url, '_blank');
        // ele.setAttribute("class", "bi bi-arrow-down-circle-fill download-Manifest-btn");
      }
    }).catch((err) => console.log(err))
  }

  const submitVerifyManifest = async () => {
    // const isValidStep1 = verManifestValidation.step0()
    // if (!isValidStep1) return
    // const isValidStep2 = verManifestValidation.step2()
    // if (!isValidStep2) return
    let isAnyUpdate = false;
    try {
      // 0
      // if (Number(verTrPrice) !== Number(currentClickedOrder?.order?.products[0].purchase_price)) {
      //   let tpData = {
      //     product: currentClickedOrder?.product,
      //     price: verTrPrice,
      //     url: currentClickedOrder?.order?.products[0]?.selSubPrd?.url ? currentClickedOrder?.order?.products[0]?.selSubPrd?.url : null
      //   }
      //   await api.transferprice.priceChangeRquest(tpData)
      //   isAnyUpdate = true
      // }
      // 1
      if (currentClickedOrder?.order?.products[0]?.sellerWeightChangeSts !== "V_ACTIVE" && currentClickedOrder?.order?.products[0]?.sellerWeightChangeSts !== "T_ACTIVE") {

        if (acceptPackageSelected || arePackagesEqual(packages, initialPackages)) {
          await updateSellerWeightChangeSts("V_ACTIVE")
          isAnyUpdate = true
           if (isWeightVerifyOnly) {
              // ✅ Weight verify only — just reload, don't download manifest
              alert.info("Weight verified. You can now download the manifest.")
              getOrders()
              setIsWeightVerifyOnly(false)
              setCurrentStep(1)
              setVerifyManifestPopup(false)
              setWeightChangeStatus(null)
              return; // ✅ STOP — do not call downloadManifest()
            }

            downloadManifest() // only runs when NOT weight-verify-only
        }
        else {
          let pkgData;
          pkgData = {
            orderId: currentClickedOrder?.order?.orderId,
            product: currentClickedOrder?.product,
            status: "T_PENDING",
            pkg: currentClickedOrder?.order?.products[0]?.selSubPrd?.url ? { url: currentClickedOrder?.order?.products[0]?.selSubPrd?.url, pkgs: dimensionUnit === "ft" ? packagesFttoCm(packages) : packages } :
              { productName: currentClickedOrder?.order?.products[0]?.productId?.productName, pkgs: dimensionUnit === "ft" ? packagesFttoCm(packages) : packages },
            categories: currentClickedOrder?.order?.products[0]?.productId?.categories,
            requestType: "EXISTING_PRODUCT"
          };
          const sanitizedPkgData = sanitizePkgImages(pkgData);
          await api.product.saveSellerWeightChangeReq(sanitizedPkgData)
          isAnyUpdate = true
        }
      }
      // 2
      // if (Number(currentStock) !== Number(currentClickedOrder?.stock)) {
      //   let stockData = {
      //     _id: currentClickedOrder?.product,
      //     stock: currentStock,
      //     url: currentClickedOrder?.order?.products[0]?.selSubPrd?.url ? currentClickedOrder?.order?.products[0]?.selSubPrd?.url : null
      //   }
      //   await api.product.addToExProduct(stockData)
      //   isAnyUpdate = true
      // }
      if (isAnyUpdate) {
        getOrders()
        alert.success("updated")
      }
      setCurrentStep(1)
      setVerifyManifestPopup(false)
      setWeightChangeStatus(null)
    } catch (err) {
      alert.error(err)
    }
  }

  const handleModalGoBack = (step) => {
    console.log(step, currentStep)
    if (step < currentStep) {
      setCurrentStep(step)
    }
  }

  const handlePackageRequestReject = () => {
    setRejectPackageSelected(true)
  }

  const styles = {
    verifyManifestPopup: {
      headerDiv: {
        display: 'flex',
        width: '100%'
      },
      headerBtns: {
        flex: 1,
        border: 'none',
        boxShadow: '0px 1px 0px 0.5px grey',
        padding: '4px 0px',
        fontSize: "14px"
      },
      vtpPara: {
        textAlign: 'left',
        fontSize: '16px',
      },
      imageBox: {
        height: "98px"
      },
      pName: {
        textAlign: 'left',
        fontSize: '16px',
      },
      sku: {
        textAlign: 'left',
      },
      confirmBtn: {

      },
      label: {
        display: 'flex',
        justifyContent: 'center'
      },
      tpInput: {
        width: '100%',
        padding: '2px 15px 2px 12%',
        fontWeight: 'bold',
        letterSpacing: '0.5px'
      },
      rsLabel: {
        position: 'absolute',
        top: '3px',
        left: '5%',
        // fontWeight:'800 !important'
      },
      tpTitle: {
        color: 'black',
      },
      sUpdateContainer: {
        position: 'relative',
        textAlign: 'center',
      },
      cStockTitle: {
        position: 'absolute',
        transform: 'translateY(-50%)',
        top: '0px',
        marginLeft: '12px',
        zIndex: 1,
        padding: '0px 4px',
        background: 'white',
      },
      cStockInput: {
        padding: '4px 15px 4px 10px',
        fontSize: '14px'
      },
      endBtnContainer: {
        textAlign: 'end',
        marginTop: '40px'
      },
      submitBtn: {
        color: '#fff',
        background: '#165b5b',
        borderRadius: '4px',
        padding: "4px 20px",
        borderStyle: 'none',
        fontSize: '14px',
        boxShadow: '0 .2em 1em -.2em #d0d0d0'
      },
      backBtn: {
        color: 'white',
        background: '#909090',
        borderRadius: '4px',
        padding: "4px 15px",
        borderStyle: 'none',
        fontSize: '14px',
        boxShadow: '0 .2em 1em -.2em #d0d0d0',
      },
      tpEdit: {
        top: '3px',
        position: 'absolute',
        right: '2px',
        cursor: 'pointer'
      },
      stockEdit: {
        top: '-1px',
        position: 'absolute',
        right: '2px',
        cursor: 'pointer'
      },
    }
  }


  const hasActiveWrongProductReport = (item) => {
    // Check if there are wrong product reports at order level
    if (item.order?.wrongProductReports && Array.isArray(item.order.wrongProductReports) && item.order.wrongProductReports.length > 0) {
      return true; // ✅ Make sure this line exists!
    }
    return false;
  };

  const getLatestWrongProductReportMessage = (item) => {
    if (item.order?.wrongProductReports && item.order.wrongProductReports.length > 0) {
      // Sort by timestamp and get the latest pending/active report
      const activePendingReports = item.order.wrongProductReports
        .filter(report => report.status === 'PENDING' || report.status === 'ACTIVE')
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

      if (activePendingReports.length > 0) {
        return activePendingReports[0]?.message || 'Product issue reported';
      }
    }

    return '';
  };

    const getWrongProductReportsCount = (item) => {
    if (item.order?.wrongProductReports) {
      return item.order.wrongProductReports.length;
    }

    return item.order?.totalReportsCount || 0;
  };

  /**
   * Search By Keyword On Enter
   */
  const searchByKeyword = (value, type, productIds) => {

    if (productIds.length > 0) {
      applyLoader()
      if (type === "sku") {
        globalFilter['filters'] = { ...globalFilter.filters, "product-objectId": productIds?.[0] }
        if (globalFilter?.searchIds)
          delete globalFilter['searchIds'];
      }
      else {
        globalFilter['searchIds'] = productIds
      }
      //Search Issue on Other than 1st Page SL-698 and SL-675
      globalFilter.pageNo = 1;
      setSelectedPage(1);
      api.order?.orders(filterOrders(globalFilter))
        .then((res) => {
          removeLoader()
          setallOrders(res.data)
          setallRecords(res.totalRecords)
        }).catch(err => {
          removeLoader()
          console.log(err)
        })


    }
    else {
      setallOrders([]);
      setallRecords(0);

    }
  }
  //</End-Here> Serach Ticket: SL-675
  return (
    <>

      <div className="" id="orDeskContain">
        {/* New orders desktop */}
        <div class="tab">
          {/* Date container */}
          <div className='d-flex mb-3 justify-content-start'>
            {/* ******** */}
            <div className='theme-shed1 p-2'>
              <div className='m-auto mt-1'>
                {/*<Start-Here> Remove Date SL-699 */}
                {/*<span className='payment_dates'>From: - <input type='date' min={minValDate} value={sortHistdatefrom} onChange={(e) => setdateweb(e, "from")}></input></span>
                <span className='mx-2 payment_dates'>To: - <input type='date' value={sortHistdateto} onChange={(e) => setdateweb(e, "to")}></input></span>
                <span><button className='apply-btn px-3 py-1 ff_Pop fs-14' onClick={() => applyFilter()}>Apply</button></span>*/}
                {/*</End-Here> Remove Date SL-699 */}
                {isBreachingFilter && <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => removeBreachingSoonFilter()}>Clear</button></span>}
                {breachingDataCount > 0 &&
                  <span>
                    <button className='apply-btn px-3 py-1 ff_Pop fs-14 breachingBtn' onClick={() => applyBreachingSoonFilter()}>
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                      Breaching Soon({breachingDataCount})
                      <OverlayTrigger
                        key="transfer"
                        placement="right"
                        overlay={
                          <Tooltip
                            id={`tooltip-transfer`}
                            className="fs-10 order_page_tooltip"
                          >
                            <p className="fs-10 f-500 order_page_tooltip_1">
                              Late dispatch will imact your rating <br />
                              and might lead to penalty in future
                            </p>
                          </Tooltip>
                        }
                      >
                        <i class="bi bi-info-circle ms-1"></i>
                      </OverlayTrigger>
                    </button>
                  </span>}
              </div>
            </div>
            {/* ****** */}
          </div>
          <div className='table-responsive'>
            <table className='ord_table new-table-design' style={{ "width": "100%" }}>
              <thead>
                <tr className='table_ord_title_row'>

                  <th className='thead_title' style={{ "width": "10%" }}>Order ID
                    <br></br>
                    <input type="text" value={orderId} name="name" placeholder='Search' className='w-90 order_table_srch_input' onChange={(e) => setOrderId(e.target.value)} onKeyUp={(e) => checkevent(e, "id")} />
                    <i class="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true" onClick={() => checkevent({ "keyCode": 13 }, "id")}></i>
                  </th>

                  <th className='thead_title pb-1' style={{ "width": "6%" }}>Assign Date
                  </th>

                  <th className='thead_title' style={{ "width": "10%" }}>Product image</th>

                  <th className='thead_title' style={{ "width": "25%" }}>Product Name & SKU
                    <br/>
                    <OrderSKUSearch
                      filterSearch={filterSearch}
                      searchNewEnq={setorderName}
                      from={"orders"}
                      flag="Order" // set flag
                      apiCall={ApiCalling}
                      data="filedData"
                      totalRcordId={totalRcordId}
                      searchByKeyword={searchByKeyword}
                      apiurl="searchSellerOrdersFilter"
                      ordersSearchParam={filterOrders(globalFilter)}
                    />
                  </th>

                  <th className='thead_title' style={{ "width": "9%" }}>Transfer price</th>
                  {stateData?.addresses?.data?.length > 0 && (
                    <th className='thead_title' style={{ "width": "10%" }}>Pickup Address
                      {/*<Start-Here> Pickup Address Dropdown | Ticket : SL-923 */}
                      <div className="dropdown-wrapper">
                        <select
                          value={addressName}
                          onChange={(e) => {
                          const value = e.target.value;
                          setAddressName(value);
                          //Immediately trigger search after selection
                          checkevent({ keyCode: 13 }, "address", value);
                        }}
                      >
                        <option value="">All</option>
                        {stateData?.addresses?.data.map((address) => (
                          <option key={address._id} value={address.firstName}>
                            {address.firstName}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/*</End-Here> Pickup Address Dropdown | Ticket : SL-923 */}
                    {/*<input type="text" value={addressName} name="name" id="inputnameweb" placeholder='Search..' className='w-95 order_table_srch_input' onChange={(e) => setAddressName(e.target.value)} onKeyUp={(e) => checkevent(e, "address")} />
                    <i className="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true" onClick={() => checkevent({ "keyCode": 13 }, "address")}></i>*/}
                  </th>
                  )}
                  <th className='thead_title' style={{ "width": "5%" }}>Total package</th>
                  <th className='thead_title' style={{ "width": "10%" }}>Order Pending From
                    <i class="fa fa-sort" onClick={() => sort('createdAt')}></i>
                  </th>

                  <th className='thead_title' style={{ "width": "19%" }}>Action required</th>
                </tr>

              </thead>
              <tbody>
                {allOrders && allOrders.length > 0 ? allOrders.map((item, index) => {
                  let baseImg;
                  let date = new Date(item?.order?.orderPlaceDate);
                  let d = date.toUTCString(item?.order?.orderPlaceDate);
                  let newd = d.substr(4, 12)
                  let update = new Date(item.updatedAt);
                  let upd = update.toUTCString(item.updatedAt);
                  let upnewd = upd.substr(4, 12)
                  if (item?.order?.products?.length > 0) {
                    item.order?.products[0].productId.images.map((item) => {
                      if (item.baseImage === true) {
                        if (item.image.startsWith("products")) {
                          baseImg = item.image;
                        }
                        else {
                          let img = item.image.substr("41")
                          baseImg = img;
                        }
                      }
                    })
                    if (item.order?.products[0].selSubPrd && item.order?.products[0].productId.combination) {
                      let showVerifyToGenManifest = true;
                      if (item.order?.products?.[0]?.sellerWeightChangeSts === "T_ACTIVE" || item.order?.products?.[0]?.sellerWeightChangeSts === "V_ACTIVE") {
                        showVerifyToGenManifest = false;
                      }
                      return (
                        <OrderCardWeb id={index}
                          key={item._id}
                          updatedAt={upnewd}
                          type="New-Orders"
                          from="New-Orders"
                          lead={item._id}
                          taxClass={item.order?.products?.[0]?.vendorDetails?.taxClass}
                          sku={item.order?.products[0].productId.SKU}
                          date={newd}
                          showVerifyToGenManifest={showVerifyToGenManifest}
                          nicknameAdd={item.order?.products && item.order?.products[0] && item.order?.products[0].vendorDetails && item.order?.products[0].vendorDetails.addrName ? item.order?.products[0].vendorDetails.addrName : undefined}
                          actualdate={item?.createdAt}
                          orderId={item.order?.orderId}
                          isWeightVerified={(item.order?.products?.[0]?.sellerWeightChangeSts === "V_ACTIVE" || item.order?.products?.[0]?.sellerWeightChangeSts === "T_ACTIVE") ? true : false}
                          isPriceReq={item.order?.products?.[0]?.isPriceReq}
                          stock={item.order?.products?.[0]?.stock}
                          url={item.order?.products[0].productId.urlKey}
                          productName={item.order?.products[0].productId.productName}
                          price={item.order?.products[0].purchase_price}
                          quantity={item.order?.products[0].quantity}
                          status={item.status}
                          downloadManifestToast={downloadManifestToast}
                          invoices={item.order?.products[0].tracks}
                          isProductPickedFun={productPicked}
                          image={baseImg}
                          popupdetailVis={setpopupVisibilityDetail}
                          popupVisibility={setpopupVisibilitytrackWeb}
                          selSubPrdVal={item.order?.products[0].selSubPrd.value}
                          pdetail={detail}
                          vendor={item.vendor}
                          revokes={item.order?.products[0].revokes}
                          combination={item.order?.products[0].productId.combination[0].value}
                          isManifestDownloadedFun={isManifestDownloaded}
                          revokeReason={item.revoke}
                          fun={trackPopupWeb}
                          orderForwardedToSeller={item.order?.orderForwardedToSeller}
                          orderMainId={item.order?._id}
                          docketNotGenerated={item.order?.docketNotGenerated}
                          sellerManfUnderProcess={item.order?.sellerManfUnderProcess}
                          manifestDetailsVerify={manifestDetailsVerify}
                          sellerWeightChangeSts={item.order?.products?.[0]?.sellerWeightChangeSts}
                          //Platform Fee Ticket : SL-662
                          platformFee={item.order?.pfFees}
                          //SL-914
                          showRaiseConcern={showRaiseConcern}
                          // l1-2319 (2-9-25)
                          HSN={item.order?.products?.[0]?.HSN}
                          handleHSNModal={handleHSNModalOpen}
                          orderData={item}
                          order={item.order}
                          product={item.order?.products?.[0]?.productId}  // ✅ ADD THIS LINE
                          //handleOpenSelfShipModal={handleOpenSelfShipModal} // ✅ ADD THIS LINE
                          reload={getOrders}
                          hasWrongProductReport={hasActiveWrongProductReport(item)}
                          wrongProductReportMessage={getLatestWrongProductReportMessage(item)}
                          wrongProductReportsCount={getWrongProductReportsCount(item)}
                          wrongProReportStatus={item?.order?.wrongProReportStatus}
                        />
                      )
                    }
                    else {
                      let showVerifyToGenManifest = true;
                      if (item.order?.products?.[0]?.sellerWeightChangeSts === "T_ACTIVE" || item.order?.products?.[0]?.sellerWeightChangeSts === "V_ACTIVE") {
                        showVerifyToGenManifest = false;
                      }
                      return (
                        <OrderCardWeb id={index}
                          key={item._id}
                          updatedAt={upnewd}
                          type="New-Orders"
                          from="New-Orders"
                          taxClass={item.order?.products?.[0]?.vendorDetails?.taxClass}
                          lead={item._id}
                          nicknameAdd={item.order?.products && item.order?.products[0] && item.order?.products[0].vendorDetails && item.order?.products[0].vendorDetails.addrName ? item.order?.products[0].vendorDetails.addrName : undefined}
                          date={newd}
                          showVerifyToGenManifest={showVerifyToGenManifest}
                          pdetail={detail}
                          actualdate={item?.createdAt}
                          isWeightVerified={(item.order?.products?.[0]?.sellerWeightChangeSts === "V_ACTIVE" || item.order?.products?.[0]?.sellerWeightChangeSts === "T_ACTIVE") ? true : false}
                          isPriceReq={item.order?.products?.[0]?.isPriceReq}
                          stock={item.order?.products?.[0]?.stock}
                          sku={item.order?.products[0].productId.SKU}
                          url={item.order?.products[0].productId.urlKey}
                          popupdetailVis={setpopupVisibilityDetail}
                          revokes={item.order?.products[0].revokes}
                          orderId={item.order?.orderId}
                          downloadManifestToast={downloadManifestToast}
                          productName={item.order?.products[0].productId.productName}
                          price={item.order?.products[0].purchase_price}
                          quantity={item.order?.products[0].quantity}
                          status={item.status}
                          invoices={item.order?.products[0].tracks}
                          isProductPickedFun={productPicked}
                          image={baseImg}
                          revokeReason={item.revoke}
                          vendor={item.vendor}
                          popupVisibility={setpopupVisibilitytrackWeb}
                          isManifestDownloadedFun={isManifestDownloaded}
                          fun={trackPopupWeb}
                          orderForwardedToSeller={item.order?.orderForwardedToSeller}
                          orderMainId={item.order?._id}
                          docketNotGenerated={item.order?.docketNotGenerated}
                          sellerManfUnderProcess={item.order?.sellerManfUnderProcess}
                          manifestDetailsVerify={manifestDetailsVerify}
                          sellerWeightChangeSts={item.order?.products?.[0]?.sellerWeightChangeSts}
                          //Platform Fee Ticket : SL-662
                          platformFee={item.order?.pfFees}
                          //SL-914
                          showRaiseConcern={showRaiseConcern}
                          // l1-2319 (2-9-25)
                          HSN={item.order?.products?.[0]?.HSN}
                          handleHSNModal={handleHSNModalOpen}
                          orderData={item}
                          order={item.order}
                          product={item.order?.products?.[0]?.productId}  // ✅ ADD THIS LINE
                          //handleOpenSelfShipModal={handleOpenSelfShipModal} 
                          reload={getOrders}
                          hasWrongProductReport={hasActiveWrongProductReport(item)}
                          wrongProductReportMessage={getLatestWrongProductReportMessage(item)}
                          wrongProductReportsCount={getWrongProductReportsCount(item)}
                          wrongProReportStatus={item?.order?.wrongProReportStatus}
                        />
                      )
                    }

                  }
                  else {

                    return (
                      <OrderCardWeb id={index}
                        type="New-Orders"
                        from="New-Orders"
                        lead={item._id}
                        actualdate={item?.createdAt}
                        orderId={item.order?.orderId}
                        status="noprodetail"
                        downloadManifestToast={downloadManifestToast}
                        productName={item.order?.products[0].productId.productName}
                        price={item.order?.products[0].purchase_price}
                        quantity={item.order?.products[0].quantity}
                        invoices={item.order?.products[0].tracks}
                        isProductPickedFun={productPicked}
                        image={baseImg}
                        revokeReason={item.revoke}
                        vendor={item.vendor}
                        popupVisibility={setpopupVisibilitytrackWeb}
                        isManifestDownloadedFun={isManifestDownloaded}
                        fun={trackPopupWeb}
                        orderForwardedToSeller={item.order?.orderForwardedToSeller}
                        orderMainId={item.order?._id}
                        docketNotGenerated={item.order?.docketNotGenerated}
                        sellerManfUnderProcess={item.order?.sellerManfUnderProcess}
                        showRaiseConcern={showRaiseConcern}
                        //Platform Fee Ticket : SL-662
                        platformFee={item.order?.pfFees}
                        // l1-2319 (2-9-25)
                        HSN={item.order?.products?.[0]?.HSN}
                        handleHSNModal={handleHSNModalOpen}
                        orderData={item}
                        order={item.order}
                        reload={getOrders}
                      />
                    )
                  }

                }) : ennewloader === "none" ? (
                  <>
                    <tr className="order-no-results-row">
                      <td colSpan={stateData?.addresses?.data?.length > 0 ? 9 : 8} className="order-no-results-cell">No Results Found</td>
                    </tr>
                  </>
                ) : null}
              </tbody>
            </table>
          </div>
          {/* </Container> */}

          <div class="d-flex justify-content-center" id="enNewLoader" >
            <div style={{ "display": ennewloader }}>
              <MainLoader/>
            </div>
          </div>

          <PaginationCom
            number={allRecords}
            activ={selectedPage}
            paginate={paginate}
            comp={compforPaginationweb}
          />
        </div>



        {/* </div> */}

        {/* Toast */}
        <Toast show={showToast} className="ToastHome" onClose={() => setshowToast(false)}>
          <Toast.Header>
            <strong className="me-auto">Message</strong>
          </Toast.Header>
          <Toast.Body>{toastmsg}.</Toast.Body>
        </Toast>



        {/* Modal Confirmation */}

        <Modal
          show={confirmationState}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered>

          {confirmationFor === "negotiate" ? <ConfirmationModal
            from="negotiate"
            onHide={confirmationBoxHiding}
            selectedId={selectedOrder}
            msg={msgConfirmation}
            responseconfirmationFun={responseConfirmNegotiate}
          /> : <ConfirmationModal
            type={confirmationType}
            onHide={confirmationBoxHiding}
            pId={selectedOrdername}
            selectedId={selectedOrder}
            msg={msgConfirmation}
            responseconfirmationFun={responseconfirmation}
          />}

        </Modal>




        {/* Track detail for web */}


        {allOrders.length > 0 ? <div id="popupTrackweb" className="overlay" style={{ "display": isPopupTrackVisWeb }}>
          {allOrders?.[selectedtrackOrderWeb]?.order?.products?.length > 0 ? allOrders?.[selectedtrackOrderWeb]?.order?.products?.[0]?.tracks.length > 0 ? <TrackOrderPopup
            type="New-Orders"
            id={allOrders?.[selectedtrackOrderWeb]?._id}
            trackDetail={allOrders?.[selectedtrackOrderWeb]?.order?.products?.[0]?.tracks?.[selectedTrackwithin]?.transitDetail}
            popupVisibility={setpopupVisibilitytrackWeb}
          /> : <></> : <></>}


        </div> : <></>}


        <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
          <Popup
            from="newOrder"
            description={productDetail[0].description}
            sdescription={productDetail[0].shortDescription}
            descriptionNew={productDetail[0].descriptionNew}
            specificationNew={productDetail[0].specificationNew}
            name={productDetail[0].productName}
            price={detailPPrice}
            SKU={productDetail[0].SKU}
            popupVisibility={setpopupVisibilityDetail}
            images={productDetail[0].images}
            videos={productDetail[0].videos}
            fixedImage={true}
          />
        </div>

        {/* sl-712 */}

        <Modal
          show={verifyManifestPopup}
          className="updtProPopModal orderManVerModal"
          centered
        >
          {/* <Modal.Header>
          <div style={styles.verifyManifestPopup.headerDiv}>
            <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 0 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(0)}>Step 1</button>
            <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 1 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(1)}>Step 2</button>
            <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 2 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(2)}>Step 3</button>
          </div>
        </Modal.Header> */}
          <Modal.Body className="updtProPopModal_body p_3px">
            <a class="close mt-1" onClick={() => {
              dispatch(resetPackages())
              setVerifyManifestPopup(false)
              setCurrentStep(0)
            }}>
              &times;
            </a>
            <p style={styles.verifyManifestPopup.vtpPara}>{variables.variables.orderModalTitles[currentStep]}</p>
            <Row className="">
              <div className="col-md-3 ">
                <div
                  className="catalog-img-border"
                  style={{
                    ...styles.verifyManifestPopup.imageBox,
                    background: `url(
                    "https://s3.toolsvilla.com/${currentClickedOrder?.order?.products?.[0]?.productId?.images[0]?.image}"
                  )`,
                  }}
                >
                </div>
              </div>
              <div className="col-md-9 py-1">
                <p className="product-name ff_pop" style={styles.verifyManifestPopup.pName}>{currentClickedOrder?.order?.products?.[0]?.productId?.productName}</p>
                <p className="sku" style={styles.verifyManifestPopup.sku}>{currentClickedOrder?.order?.products?.[0]?.productId?.SKU}</p>
                <p className="sku" style={styles.verifyManifestPopup.sku}>{clickedProDets?.manufacturerName}</p>
                <ul className="d-flex ord-crd mb-0">
                  {currentClickedOrder?.order?.products?.[0]?.selSubPrd?.value && currentClickedOrder.order.products[0].selSubPrd.value.map((item, index) => {
                    return (
                      <>
                        <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{currentClickedOrder?.order?.products?.[0]?.productId?.combination[0]?.value[index]} - {item}</li>
                      </>
                    )
                  })
                  }
                </ul>
              </div>
            </Row>

            {/* sl- 712 */}
            {/* Verify Transfer Price */}
            {currentStep === 0 && <>
              <Row className="text-center mt-1">
                <div className="col-12 ">
                  <form className="">
                    <label style={styles.verifyManifestPopup.label}>
                      <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                        Transfer Price (incl. {currentClickedOrder?.order?.products?.[0]?.vendorDetails?.taxClass}% GST) :
                      </span>
                      <span className="position-relative ms-1">
                        <input
                          type="number"
                          autocomplete="off"
                          minLength="1"
                          value={verTrPrice}
                          style={styles.verifyManifestPopup.tpInput}
                          required
                          disabled={tpDisabled}
                          onChange={(e) => setVerTrPrice(e.target.value)}
                          onWheel={(e) => e.target.blur()}
                        />
                        <span style={styles.verifyManifestPopup.rsLabel}><i className="bi bi-currency-rupee" style={{ fontWeight: 'bold !important' }}></i></span>
                        <span style={styles.verifyManifestPopup.tpEdit}><i className="bi bi-pencil" style={{ fontWeight: 'bold !important' }} onClick={() => setTpDisabled(false)}></i></span>
                      </span>
                    </label>
                  </form>
                </div>
              </Row>

              <p style={styles.verifyManifestPopup.endBtnContainer}>
                <button style={styles.verifyManifestPopup.submitBtn} onClick={() => verSubmitTPrice(1)}>Confirm & Proceed</button>
              </p>
            </>}
            {/* Package Information */}
            {currentStep === 1 && <div className='detail-new'>
              <WeightComponent
                viewOnly={(weightChangeStatus === "T_PENDING" || weightChangeStatus === "T_ACTIVE" || weightChangeStatus === "V_ACTIVE") ? true : false}
                // backButton={"Back"}
                // proceedButton={"Proceed"}
                proceed={() => setCurrentStep(2)}
                handleSubmit={handleVerPackageSubmission}
                handleBackPressWeight={() => setCurrentStep(0)}
                weightRequest={weightChangeStatus === "V_PENDING" ? true : false}
                weightChangeStatus={weightChangeStatus}
                handleAcceptPackage={handleAcceptPackage}
                handlePackageRequestReject={handlePackageRequestReject}
                rejectPackageSelected={rejectPackageSelected}
                showRejectMessage={true}
              />
            </div>
            }
            {/* Stock Update */}
            {
              currentStep === 2 && <>
                <Row>
                  <div style={styles.verifyManifestPopup.sUpdateContainer} className='col-12'>
                    <span style={styles.verifyManifestPopup.cStockTitle}>Current Stock</span>
                    <span className="position-relative ms-1">
                      <input
                        type="number"
                        value={currentStock}
                        disabled={stockDisabled}
                        onWheel={(e) => e.target.blur()}
                        style={styles.verifyManifestPopup.cStockInput} onChange={(e) => setCurrentStock(e.target.value)} />
                      <span style={styles.verifyManifestPopup.stockEdit}><i className="bi bi-pencil" style={{ fontWeight: 'bold !important' }} onClick={() => setStockDisabled(false)}></i></span>
                    </span>
                  </div>
                </Row>
                <p style={styles.verifyManifestPopup.endBtnContainer}>
                  <button style={styles.verifyManifestPopup.backBtn} onClick={() => setCurrentStep(1)}>Back</button>
                  <button className='ms-2' style={styles.verifyManifestPopup.submitBtn} onClick={() => submitVerifyManifest()}>Confirm & Proceed</button>
                </p>
              </>
            }
          </Modal.Body>
        </Modal>


        {/*<Start-Here> Raise Concern Ticket: SL-669 */}
        {show ? (
          <RaiseConcernModal
            show={show}
            handleClose={handleRaiseConcernClose}
            submitRaiseConcern={submitRaiseConcern}
          />
        ) : (
          ""
        )}
        {/*</End-Here> Raise Concern Ticket: SL-669 */}

        {/* HSN Modal l1-2319 (2-9-25) */}
        <HSNModal
          show={showHSNModal}
          handleCloseModal={handleHSNModalClose}
          handleHSNModalOpen={handleHSNModalOpen}
          productData={currentProduct}
          onSave={handleHSNModalSave}
          from="Unprocessed Orders"
        />
        {/* </End-Here> HSN Modal l1-2319 (2-9-25) */}
      </div>
    </>
  )
}


export default UnProcessedOrders;